import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {KiotTypeField} from "./KiotType";

const KiotConfigFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const KiotConfigList = props => (
    <List filters={<KiotConfigFilter/>} {...props} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="retailerId"/>
            <TextField source="branchId"/>
            <TextField source="saleChannelId"/>
            <KiotTypeField source="type"/>
        </Datagrid>
    </List>
);

export default KiotConfigList
